<template>
  <div class="mt-2 p-4">
    <CRow>
      <CCol sm="12">
        <h5 style="color:black">Dashboard Super Administrator</h5>
        <hr class="mt-2 mb-4"/>
      </CCol>
    </CRow>
    <CRow>
      <CCol xs="12" lg="12" class="bgTab">
          <CCardBody class="p-0 pb-3 pt-3">
            <CTabs add-tab-classes="mt-1">
              <CTab @click.native="changeTab(1)">
                <template slot="title">
                  {{tabs[0]}}
                </template>
              </CTab>
              <CTab @click.native="changeTab(2)">
                <template slot="title">
                  {{tabs[1]}}
                </template>
              </CTab>
              <CTab @click.native="changeTab(3)">
                <template slot="title">
                  {{tabs[2]}}
                </template>
              </CTab>
            </CTabs>
          </CCardBody>
      </CCol>
    </CRow>
    <CRow class="mb-4">
        <CCol sm="3 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total User</div>
                    <div class="card-subtitle">Total Semua Data User Pengguna iOffice Plus</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;" class="text-left">{{totalPengguna}}</span>
                        <!-- <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{wfh}}</span> -->
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> User</span>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="3 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Akses Dashboard</div>
                    <div class="card-subtitle">Total Data Transaksi Dashboard iOffice Plus {{waktu}} Ini</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{totalTransaksi}}</span>
                        <!-- <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{wfo}}</span> -->
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Transaksi</span>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="3 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Pengajuan</div>
                    <div class="card-subtitle">Total pengguna melakukan pengajuan di iOffice Plus {{waktu}} Ini</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{totalPengajuan}}</span>
                        <!-- <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{cuti}}</span> -->
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pengajuan</span>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="3 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Perusahaan</div>
                    <div class="card-subtitle">Total Perusahaan Pengguna iOffice Plus</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-12">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{totalPerusahaan}}</span>
                        <!-- <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{telat}}</span> -->
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Perusahaan</span>
                    </div>
                </div>
            </div>
        </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CRow>
          <CCol sm="6">
            <TotalUserChart :keterangan="keterangan" :dataUser="dataUser" :transaksi="transaksi"/>
          </CCol>
          <CCol sm="6">
            <AktifChart :keterangan="keterangan" :checkin="checkin" :checkout="checkout"/>
          </CCol>
          <CCol sm="6">
            <TotalTransaksiChart :keterangan="keterangan" :transaksi="transaksi"/>
          </CCol>
          <CCol sm="6">
            <TotalPengajuanChart :keterangan="keterangan" :pengajuan="pengajuan"/>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <DeviceChart :hitDevice="hitDevice" :deviceAndroid="deviceAndroid" :deviceIos="deviceIos" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow class="mt-5 mb-4">
      <CCol sm="8 text-left">
        <h5>
          Monitoring Perusahaan Pengguna iOffice Plus
        </h5>
      </CCol>
      <CCol sm="4 text-right">
        <model-select :options="dataPerusahaan" class="form-control" v-model="perusahaan" placeholder="Pilih Perusahaan"></model-select>
      </CCol>
    </CRow>
    <CRow v-if="perusahaan.value != ''">
      <CCol sm="6">
        <UserChart :userNama="userNama" :userSisa="userSisa" :userExp="userExp" :userAktif="userAktif" :userTidakAktif="userTidakAktif" />
      </CCol>
      <CCol sm="6">
        <TransaksiPerusahaan :list="list" :listTransaksi="listTransaksi" :listPengajuan="listPengajuan" :userNama="userNama" />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import TotalUserChart from '../../widgets/TotalUserChart.vue';
import TotalTransaksiChart from '../../widgets/TotalTransaksiChart.vue';
import TotalPengajuanChart from '../../widgets/TotalPengajuanChart.vue';
import UserChart from '../../widgets/UserChart.vue';
import DeviceChart from '../../widgets/DeviceChart.vue';
import AktifChart from '../../widgets/AktifChart.vue';
import TransaksiPerusahaan from '../../widgets/TransaksiPerusahaan.vue';
import { DataApi } from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'Dashboard',
  components: {
    ModelSelect,
    TotalUserChart,
    TotalTransaksiChart,
    TotalPengajuanChart,
    UserChart,
    DeviceChart,
    AktifChart,
    TransaksiPerusahaan
  },
  data () {
    return {
      type: '',
      page: 1,
      size: 20,
      totalRow: 0,
      totalPage: 1,
      firstPage: 0,
      lastPage: 0,

      tabs: [
      'Tahun',
      'Bulan',
      'Hari'
      ],
      waktu: 'Tahun',
      tab: 1,
      activeTab: 1,

      totalPengajuan: 0,
      totalPengguna: 0,
      totalPerusahaan: 0,
      totalTransaksi: 0,

      keterangan: '',
      aktif: '',
      tidakAktif: '',
      dataUser: '',
      pengajuan: '',
      transaksi: '',

      iconWfh: require('../../../assets/menu/icon_home.svg'),
      closeIcon: require('../../../assets/menu/icon_close.svg'),
      iconWfo: require('../../../assets/menu/icon_office.svg'),
      iconCuti: require('../../../assets/menu/icon_leave_blue.svg'),
      iconTelat: require('../../../assets/menu/icon_late.svg'),

      userNama: '',
      userSisa: '',
      userExp: '',
      userAktif: '',
      userTidakAktif: '',

      list: '',
      listTransaksi: '',
      listPengajuan: '',

      checkin: '',
      checkout: '',

      deviceAndroid: '',
      deviceIos: '',
      deviceTotal: '',

      perusahaan: {
        value: 'AA',
        text: 'PT INDONESIA COMNETS PLUS'
      },
      dataPerusahaan: [],

      flag1: false,
      flag2: false,
    }
  },
  watch: {
    activeTab() {
      if(this.activeTab == 1) {
        this.waktu = 'Tahun'
      } else if(this.activeTab == 2) {
        this.waktu = 'Bulan'
      } else if(this.activeTab == 3) {
        this.waktu = 'Hari'
      }
      this.getDataDashboard()
    },
    flag1() {
      this.checked()
    },
    flag2() {
      this.checked()
    },
    perusahaan() {
      if(this.perusahaan.text == '') {
        //
      } else {
        this.getDataDashboard2()
      }
    }
  },
  methods: {
    changeTab(val){
      this.tab = val
      this.activeTab = val
    },
    checked() {
      if(this.flag1 == true || this.flag2 == true) {
        this.$store.state.loadingScreen = true
      } else {
        this.$store.state.loadingScreen = false
      }
    },
    getDataDashboard() {
      this.flag1 = true
      let tipe = ''
      if(this.waktu == 'Tahun') {
        tipe = 'T'
      } else if(this.waktu == 'Bulan') {
        tipe = 'B'
      } else if(this.waktu == 'Hari') {
        tipe = 'H'
      }

      DataApi.post("dashboard/superadmin?tipe=" + tipe)
      .then(res => {
          let temp = res.data.data
          this.totalPengajuan = temp.totalPengajuan
          this.totalPengguna = temp.totalPengguna
          this.totalPerusahaan = temp.totalPerusahaan
          this.totalTransaksi = temp.totalTransaksi

          this.keterangan = temp.keterangan
          this.aktif = temp.dataUserAktif
          this.tidakAktif = temp.dataUserNonAktif
          this.dataUser = temp.dataUser
          this.pengajuan = temp.pengajuan
          this.transaksi = temp.transaksi

          this.checkin = temp.checkin
          this.checkout = temp.checkout


          this.deviceAndroid = temp.android
          this.deviceIos = temp.ios
          this.deviceTotal = temp.totalDevice
          this.hitDevice = tipe

          this.flag1 = false
      })
    },
    getDataDashboard2() {
      this.flag2 = true
      let organisasi = this.perusahaan.value
      DataApi.post("dashboard/superadmin/dua?organisasi=" + organisasi)
      .then(res => {
          let temp = res.data.data
          this.userNama = temp.namaPerusahaan
          this.userSisa = temp.sisaKuota
          this.userExp = temp.tglExpired
          this.userAktif = temp.totalAktif
          this.userTidakAktif = temp.totalNonAktif
          this.list = temp.listKeterangan
          this.listTransaksi = temp.listTransaksi
          this.listPengajuan = temp.listPengajuan
          this.flag2 = false
      })
    },
    getDataPerusahaan() {
      let payload = {
        limit: 9999,
        namaOrganisasi: "",
        organisasi: "",
        pageIn: 1,
      }
      DataApi.post("perusahaan/get", payload)
      .then(response => {
        this.dataPerusahaan = []
        let temp = response.data.data.data
        var i = 0
        for(i=0;i<temp.length;i++) {
          let onPush = {
            value: temp[i].kode,
            text: temp[i].nama
          }
          this.dataPerusahaan.push(onPush)
        }
      })
    }
  },
  mounted() {
    this.getDataDashboard()
    this.getDataDashboard2()
    this.getDataPerusahaan()
  }
}
</script>

<style scoped>
.flexible {
  flex-grow: 1;
}
.card-title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modals {
  overflow-y: initial !important;
}
.bodys-modal {
  overflow-y: auto;
  height: 65vh;
}
.modal-buttons {
    width:100%;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.wrap{
    height: auto;
    width: 100%;
}
.bg-white {
  background-color: white;
}
.bgTab{
  background-color: rgba(249, 250, 252, 1);
}
.page-title{
  padding: 20px 40px 15px 40px;
}
::v-deep .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  /* border-color: ; */
  font-weight: bold;
  color: rgba(21, 100, 153, 1);
  border-bottom: 3px solid rgba(21, 100, 153, 1) !important;
  background-color: transparent;
}
::v-deep .nav-tabs .nav-item {
  border: none !important;
  border-bottom: 1px solid gainsboro;
}

::v-deep .nav-tabs .nav-link {
 padding: 14px;
 background-color: rgba(249, 250, 252, 1);
 border-bottom: 1px solid gainsboro;
}
::v-deep .nav-item a {
  color: rgba(154, 154, 154, 1);
}
::v-deep .nav-item {
  border-bottom: 1px solid gainsboro;
}
::v-deep .nav-item {
  font-weight: bold!important;
  color: #606060;
  background-color: rgba(249, 250, 252, 1);
  width: 25%;
  text-align: center;
}
</style>